
import { JSX, useEffect, useState } from "react";
import { ModalProps } from "./ModalProps";
import { XMarkIcon } from "assets";

 export default function FullScreenModal({
  showModal,
  setShowModal,
  children,
  className,
}: ModalProps): JSX.Element {
  const [isModalVisible, setIsModalVisible] = useState(false);
  useEffect(() => {
      if (showModal) {
        setTimeout(() => setIsModalVisible(true), 10);
      } else {
        setIsModalVisible(false);
      }
    }, [showModal]);
   const backdropTransition = showModal
    ? "opacity-100"
    : "opacity-0";
  const modalTransition = isModalVisible
    ? "scale-100 opacity-100"
    : "scale-95 opacity-0";
  return (
    <>
      {showModal && (
        <div
          className={`fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 ${backdropTransition} ${className}`}
        >
          <div className={`relative flex justify-center bg-white border-[1px] border-primary-500 rounded-lg  w-11/12 max-h-[90%] h-fit  shadow-lg transition-all duration-300 ease-in-out ${modalTransition}`}>
            <button
              onClick={() => setShowModal(false)}
              className="absolute border-[1px] border-primary-500 p-2 -top-3 -right-3 hover:border-red-700 hover:text-red-800 rounded-full bg-primary-50 hover:bg-red-200 hover:shadow-lg transition-all duration-300 ease-in-out"
            >
              <XMarkIcon className="size-4 text-black hover:text-red-700 transition-all duration-300 ease-in-out" />
            </button>
            <div className="max-h-[90vh] overflow-y-auto hide-scrollbar w-full p-4 ">{children}</div>
          </div>
        </div>
      )}
    </>
  );
}
